import axios from "axios";

export const userLogin = async (payload: {
  username: string;
  password: string;
}) => {
  const headers = {
    "API-Key": `${process.env.REACT_APP_API_KEY}`,
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.post(
      `${process.env.REACT_APP_HTTPS_PROTOCOL}${process.env.REACT_APP_BASE_URL}/api/users/authenticate`,
      payload,
      { headers }
    );

    localStorage.setItem("JWT", response.data);
    return true;
  } catch (error) {
    alert(error);
    return false;
  }
};

export const clearUserToken = () => {
  localStorage.removeItem("JWT");
};

export const getCurrentUserToken = (): string => {
  const token = localStorage.getItem("JWT");
  return token ?? "";
};
